"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESessionLogStatus = exports.ESessionLogStyle = exports.ESessionState = exports.ESessionResult = void 0;
var ESessionResult;
(function (ESessionResult) {
    ESessionResult["Running"] = "Running";
    ESessionResult["Success"] = "Success";
    ESessionResult["Warning"] = "Warning";
    ESessionResult["Failed"] = "Failed";
    ESessionResult["Cancelled"] = "Cancelled";
})(ESessionResult = exports.ESessionResult || (exports.ESessionResult = {}));
var ESessionState;
(function (ESessionState) {
    ESessionState["Running"] = "Running";
    ESessionState["Never Executed"] = "Never Executed";
    ESessionState["Success"] = "Success";
    ESessionState["Warning"] = "Warning";
    ESessionState["Failed"] = "Failed";
    ESessionState["Canceled"] = "Canceled";
})(ESessionState = exports.ESessionState || (exports.ESessionState = {}));
var ESessionLogStyle;
(function (ESessionLogStyle) {
    ESessionLogStyle["None"] = "None";
    ESessionLogStyle["Bold"] = "Bold";
    ESessionLogStyle["Gray"] = "Gray";
    ESessionLogStyle["Tail"] = "Tail";
})(ESessionLogStyle = exports.ESessionLogStyle || (exports.ESessionLogStyle = {}));
var ESessionLogStatus;
(function (ESessionLogStatus) {
    ESessionLogStatus["Running"] = "Running";
    ESessionLogStatus["Success"] = "Success";
    ESessionLogStatus["Warning"] = "Warning";
    ESessionLogStatus["Failed"] = "Failed";
})(ESessionLogStatus = exports.ESessionLogStatus || (exports.ESessionLogStatus = {}));
//# sourceMappingURL=types.js.map